module.exports = __webpack_public_path__ + "img/62.5.COD.cc5f3aa9.png";